import React from 'react'
import Button from '../../components/Button'

const Footer = () => {
  const year = (new Date()).getFullYear();

  return (
    <footer className="site-footer">
      <span className="site-footer__text">
        { year }. Designed & developed with ☕️ by Drew in React. Refreshed using <Button variant="link" href="https://cursor.com/">Cursor AI</Button>.
      </span>
    </footer>
  );
};

export default Footer;
